import styled from 'styled-components';
import { transparentize } from 'polished';
export var ModalBackdrop = styled.div.withConfig({
  displayName: "ModalBackdrop",
  componentId: "sc-nylxzd-0"
})(["z-index:", ";background-color:", ";position:fixed;display:block;width:100%;height:100%;top:0;left:0;"], function (_ref) {
  var theme = _ref.theme;
  return theme.zIndex.modalBackdrop;
}, function (_ref2) {
  var theme = _ref2.theme;
  return transparentize(0.3, theme.color.black);
});